import { pushEvent } from "./helpers.js";
const setUserObjectDataLayer = (userId, email) => {
  pushEvent({
    event: "user_data_loaded",
    user: {
      loginStatus: "true",
      id: {
        auth0: userId,
        auth0_email: email
      }
    }
  });
};
export {
  setUserObjectDataLayer
};
//# sourceMappingURL=user.js.map
